// SSE records may span network chunks, UTF-8 characters and multiple data lines.
export async function* readSse(stream) {
  const reader = stream.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  let data = [];
  function consume(line) {
    if (line === '') {
      const result = data.length ? data.join('\n') : undefined;
      data = [];
      return result;
    }
    if (line.startsWith('data:')) data.push(line.slice(5).replace(/^ /, ''));
  }
  try {
    while (true) {
      const {value, done} = await reader.read();
      buffer += decoder.decode(value, {stream: !done});
      let match;
      while ((match = /\r\n|\r(?!$)|\n/.exec(buffer))) {
        const line = buffer.slice(0, match.index);
        buffer = buffer.slice(match.index + match[0].length);
        const record = consume(line);
        if (record !== undefined) yield record;
      }
      if (done) break;
    }
    // SSE dispatch requires a blank line; an incomplete final record is ignored.
  } finally {
    await reader.cancel().catch(() => {});
    reader.releaseLock();
  }
}
